module.exports = __webpack_public_path__ + "static/img/zu 6.a23a0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zu 6.png
// module id = xMWL
// module chunks = 26